import { render, staticRenderFns } from "./ListLaborOrder.vue?vue&type=template&id=45e1594a"
import script from "./ListLaborOrder.vue?vue&type=script&lang=js"
export * from "./ListLaborOrder.vue?vue&type=script&lang=js"
import style0 from "./ListLaborOrder.vue?vue&type=style&index=0&id=45e1594a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports